import React, { useEffect, useState } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { IoWarning } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import "../../css/items.scss";
import "./posts.scss";

const PostList = ({ data }) => {
  const navigate = useNavigate();
  const [allItems, setAllItems] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  // const [searchText, setSearchText] = useState("");
  // const [selectedCategory, setSelectedCategory] = useState("");
  const [years, setYears] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  // Get current items
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Calculate total pages
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  // Change page
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    // serverInstance.get("/app/posts")
    //   .then(res => {
    //     res.data.items.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    //     setAllItems(res.data.items)
    //     setFilteredData(res.data.items)
    //     // Get unique years from data
    //     const years = Array.from(new Set(res.data.items?.map((item) => item.year))).sort();
    //     setYears(years)
    //     setErrorMsg("");
    //     setLoading(false);
    //   })
    //   .catch((err) => {
    //     setErrorMsg(err);
    //     setLoading(false);
    //   })
  }, []);

  // Filter data based on all criteria
  // useEffect(() => {
  //   let result = allItems;

    // Text search filter
    // if (searchText) {
    //   result = allItems.filter(
    //     (item) =>
    //       item.title.toLowerCase().includes(searchText.toLowerCase()) ||
    //       item.authors.some((author) =>
    //         author.toLowerCase().includes(searchText.toLowerCase())
    //       )
    //   );
    // }

    // Category filter
    // if (selectedCategory) {
    //   result = result.filter((item) => item.category == selectedCategory);
    // }

  //   setFilteredData(result);
  //   setCurrentPage(1);

  // }, [searchText, selectedCategory]);

  const getPageNumbers = () => {
    const pageNumbers = [];
    if (totalPages <= 5) {
      // Show all pages if total is 5 or less
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Show limited pages with ellipsis
      if (currentPage <= 3) {
        for (let i = 1; i <= 3; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push('...');
        pageNumbers.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pageNumbers.push(1);
        pageNumbers.push('...');
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      } else {
        pageNumbers.push(1);
        pageNumbers.push('...');
        pageNumbers.push(currentPage - 1);
        pageNumbers.push(currentPage);
        pageNumbers.push(currentPage + 1);
        pageNumbers.push('...');
        pageNumbers.push(totalPages);
      }
    }
    return pageNumbers;
  };

  const goTo = (index) => {
    if (index === 2) {
      window.open(data.categoryLinks[index])
    }
    else {
      navigate(data.categoryLinks[index])
    }
  }

  return (
    <div id="posts" className='items-container'>
      
      <section className="upper-section">
        <div className="upper-section-inner">
          <div className="title-container">
            <h2>{data.title}</h2>
          </div>
        </div>
      </section>
      
      {/* <div className='filters col-11'>
        <div className='filter-row'>
          <input
            type='text'
            placeholder={data.placeholder}
            className="search"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          <select
            className="category-select"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}>
            <option value=''>{data.allCategory}</option>
            {categories.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>      
        </div>
      </div> */}

      {loading ? <>
        <AiOutlineLoading3Quarters size={25} className="loading-spinner" />
      </>
        :
        <>
          {errorMsg ? <div className="error-msg">
            <IoWarning />
            &nbsp;
            {errorMsg}
          </div> : null}

          { allItems.length === 0 ?
          <div className='no-data'>
            <p>{data.noData}</p>
          </div> : null
          }

          <section className="list-main col-11">
            <div className='list'>
              {currentItems.map((item) => (
                <div key={'item-' + item.id} className='item'>
                  { item.fileUrl ?
                  <div className="item-img">
                    <img src={`https://lingo-portal-assets.s3.ap-northeast-2.amazonaws.com/${item.fileUrl}`} />
                  </div>
                  : null }
                  <div className='item-info'>
                    <div className="title">{item.title}</div>
                    <div className='desc'>{item.description}</div>

                    <Link to={"/posts/" + item.id}
                      target='_blank'
                      rel='noopener noreferrer'>
                      {data.open}
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <div className="pagination d-flex justify-content-center flex-wrap">
            <button 
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="pagination-btn mx-1">
              {"<"}
            </button>
            
            {getPageNumbers().map((number, index) => (
              <button
                key={index}
                onClick={() => number !== '...' ? handlePageChange(number) : null}
                className={`pagination-btn mx-1 ${currentPage === number ? 'active' : ''} ${number === '...' ? 'dots' : ''}`}
              >
                {number}
              </button>
            ))}
            
            <button 
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="pagination-btn mx-1">
            {">"}
            </button>
          </div>
        </>
      }
    </div>
  );
};
export default PostList;
